import axios from 'axios';

import qs from 'querystring';

import { API } from '@/api/constants';

import {
  getUserFromLocalStorage,
  saveUserDataInLocalStorage,
} from '@/utils/user';

import actions from './actions';
import removeUserFromLocalStorage from '@/utils/user/removeUserFromLocalStorage';
import { UG_HASH } from '@/utils/user/constants';

const handleLogin = (credentials) => async (dispatch) => {
  try {
    dispatch(actions.handleLoginRequest());

    const auth = {
      username: process.env.REACT_APP_CLIENT_ID,
      password: process.env.REACT_APP_CLIENT_PASSWORD,
    };

    const qsCreds = qs.encode({ ...credentials, grant_type: 'password' });

    const response = await axios.post(
      `${API}authorization/oauth/token`,
      qsCreds,
      {
        auth,
        method: 'post',
        contentType: 'application/x-www-form-urlencoded',
        maxRedirects: 0,
        transformRequest: [
          (data, headers) => {
            delete headers.common.Accept; // eslint-disable-line

            return data;
          },
        ],
      },
    );

    if (response.data.ug_hash) {
      localStorage.setItem(UG_HASH, response.data.ug_hash);
    }

    saveUserDataInLocalStorage(
      response.data.access_token,
      response.data.refresh_token,
    );

    window.dispatchEvent(new Event('USER_LOGGED'));

    dispatch(actions.handleLoginSuccess(response.data.accessToken));

    return response;
  } catch (err) {
    dispatch(actions.handleLoginFailure(err));
    throw err;
  }
};

const handleRefreshToken = () => async (dispatch) => {
  try {
    dispatch(actions.handleRefreshTokenRequest());

    const auth = {
      username: process.env.REACT_APP_CLIENT_ID,
      password: process.env.REACT_APP_CLIENT_PASSWORD,
    };

    const user = getUserFromLocalStorage();

    const qsCreds = qs.encode({
      refresh_token: user.refreshToken,
      grant_type: 'refresh_token',
    });

    const response = await axios.post(
      `${API}authorization/oauth/token`,
      qsCreds,
      {
        auth,
        method: 'POST',
        contentType: 'application/x-www-form-urlencoded;charset=utf-8',
      },
    );

    saveUserDataInLocalStorage(
      response.data.access_token,
      response.data.refresh_token,
    );

    dispatch(actions.handleRefreshTokenSuccess(response.data.accessToken));
  } catch (err) {
    dispatch(actions.handleRefreshTokenFailure());
    dispatch(handleLogout());
    throw err;
  }
};

const handleLogout = () => async (dispatch) => {
  const registration = await navigator.serviceWorker.ready;

  if (registration) {
    registration.active.postMessage({
      type: 'DISCONNECT',
    });
  }

  removeUserFromLocalStorage();

  window.dispatchEvent(new Event('USER_LOGOUT'));

  dispatch(actions.handleLogout());

  window.location.pathname = '/login';
};

const { loadUserFromToken } = actions;

const forgotPassword = (obj) => async (dispatch) => {
  try {
    dispatch(actions.forgotPasswordRequest());
    const response = await services.post(`auth/password/forgot`, obj);
    dispatch(actions.forgotPasswordSuccess(response));
    return response;
  } catch (err) {
    dispatch(actions.forgotPasswordFailure(err));
    throw err;
  }
};

// const recoverPassword = () => async (dispatch) => {
//   try {
//     dispatch(actions.recoverPasswordRequest());
//     const response = await services.post(`auth/password/change`);
//     dispatch(actions.recoverPasswordSuccess(response));
//     return response;
//   } catch (err) {
//     dispatch(actions.recoverPasswordFailure(err));
//     throw err;
//   }
// };

export default {
  handleLogin,
  handleRefreshToken,
  handleLogout,
  loadUserFromToken,
  forgotPassword,
  // recoverPassword,
};
